import React from 'react';
import clsx from 'clsx';
import { IconEmoji } from '@tribeplatform/react-components/common';
import { HtmlContent } from '@tribeplatform/react-components/HtmlContent';
import { useRouter } from '@tribeplatform/react-sdk';
import { Button } from '@tribeplatform/react-ui-kit/Button';
import { Card } from '@tribeplatform/react-ui-kit/Card';
const Action = ({ action }) => {
    const { Link } = useRouter();
    if (!action) {
        return null;
    }
    const { href, text, type, openInNewWindow } = action;
    if (!text) {
        return null;
    }
    const target = openInNewWindow ? '_blank' : undefined;
    const props = {
        href,
        target,
        className: 'inline-block truncate',
    };
    if (type === 'link') {
        return React.createElement(Link, Object.assign({}, props), text);
    }
    return (React.createElement(Button, Object.assign({ as: props => React.createElement(Link, Object.assign({}, props, { variant: "inherit" })) }, props), text));
};
export const CallToActionBlock = ({ alignment, title, description, image, action, className, style, }) => {
    var _a, _b, _c;
    let emoji;
    let img;
    if ((_a = image) === null || _a === void 0 ? void 0 : _a.url) {
        img = image;
    }
    else if ((_b = image) === null || _b === void 0 ? void 0 : _b.text) {
        emoji = image;
    }
    return (React.createElement(Card, { className: clsx('overflow-hidden', className), style: style },
        img && (React.createElement("div", { className: "bg-center bg-cover", style: {
                aspectRatio: '11/4',
                backgroundColor: img.dominantColorHex,
                backgroundImage: `url(${((_c = img.urls) === null || _c === void 0 ? void 0 : _c.medium) || img.url})`,
            } })),
        emoji && (React.createElement("div", { className: "pt-3 justify-center items-center flex" },
            React.createElement(IconEmoji, { text: emoji.text, size: "xl" }))),
        (title || description) && (React.createElement(Card.Content, { className: clsx('space-y-3', alignment === 'center' ? 'text-center' : 'text-start') },
            title && React.createElement("h4", { className: "text-content" }, title),
            description && (React.createElement("article", null,
                React.createElement(HtmlContent, { value: description, trustedDomains: ['*'] }))))),
        (action === null || action === void 0 ? void 0 : action.text) && (React.createElement(Card.Footer, { className: clsx(alignment === 'center' ? 'text-center' : 'text-start') },
            React.createElement(Action, { action: action })))));
};
//# sourceMappingURL=Block.js.map